<template>
  <div class="goals-chart-preview-table">
    <h3>{{ title }}</h3>
    <div class="row-table header">
      <div
        v-for="(item, index) of data"
        :key="index">
        {{ item.label }}
      </div>
    </div>
    <div class="row-table">
      <div
        v-for="(item, index) of data"
        :key="index">
        {{ item.doneGoal }} / {{ item.totalGoal }}
      </div>
    </div>
    <div class="row-table">
      <div
        v-for="(item, index) of periodGoals"
        :key="index">
        {{ item.done }} / {{ item.total }}
      </div>
    </div>
  </div>
</template>

<script>
/**
*
* GoalsChartPreviewTable Component
*
* @author Emmanuel Hernández
* @copyright 2019, Marciano Studio S.C.
*/
export default {
  name: 'GoalsChartPreviewTable',
  props: {
    title: {
      type: String,
      default: ''
    },
    profile: {
      type: Object,
      default: null
    },
    data: {
      type: Array,
      default: null
    }
  },
  computed: {
    periodGoals () {
      return this.periodGoalsCalc(this.data)
    }
  },
  methods: {
    periodGoalsCalc (goals) {
      let count = {
        total: 0,
        done: 0
      }
      let _periodMonths = []
      for (let item of goals) {
        count.total = item.totalGoal + count.total
        count.done = item.doneGoal + count.done
        if (item.value % 3 === 0) {
          _periodMonths.push(count)
          count = {
            total: 0,
            done: 0
          }
        }
      }
      return _periodMonths
    }
  }
}
</script>

<style lang='scss' scoped>
  .goals-chart-preview-table {
    margin: 10px 0;
    h3 {
      margin: 0;
      margin-bottom: 10px;
      @include font-primary(16px, regular);
    }
    .row-table {
      text-align: center;
      @include font-primary(12px, bold);
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(10px, 1fr));
      border-bottom: 1px solid $border-primary;
      div {
        padding: 5px 0;
        border-left: 1px solid $border-primary;
        &:last-child {
          border-right: 1px solid $border-primary;
        }
      }
      &.header {
        background-color: $primary;
        color: #ffffff;
        div {
          border-left: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/goals/goals-chart-preview-table.vue